import { Box, FormControl, FormControlLabel, FormLabel, Modal, Paper, Radio, RadioGroup, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { ChangeEvent, useEffect, useMemo, useState } from 'react'
import { MdInfo } from 'react-icons/md'
import { webApiService } from '../../../../services'
import { Button } from '@/components/ui/button'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { IConfigSeller } from '@/models/configSeller'
import { sinTrizaduras } from '@/utils/questionText'
import { useSelector } from 'react-redux'
import { useJoyRideContext } from '../context/JoyRideContext'

/* Reutilizamos las respuestas de la cotización en vez de volver a preguntar. En true se
   fuerza el cuestionario siempre, como antes. Aunque esté en false el cuestionario sigue
   apareciendo cuando la cotización no dejó respuestas para todas las preguntas. */
const SHOW_RECALCULATE_QUESTIONNAIRE = false

const Recalculate = () => {
  const [data, setData] = useState<{ loading: boolean, questionList: any[], answers: any[], open: boolean }>({ loading: false, questionList: [], answers: [], open: false })
  // Carga del catálogo de preguntas, separada del loading del recálculo: mientras corre el
  // botón no puede saber todavía si hay respuestas de la cotización.
  const [loadingQuestions, setLoadingQuestions] = useState<boolean>(true)
  const { enqueueSnackbar } = useSnackbar()
  const { ctx, saveCtx } = useTradeinContext()

  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isLiverpoolMexico = configSeller.config.s3.FOLDER_APP === 'ti_liverpool_mx'
  // Liverpool habla de "roturas", no de "trizaduras" (el texto viene de la BD compartida).
  const textoPregunta = (texto: any): any => (isLiverpoolMexico ? sinTrizaduras(texto) : texto)
  const isXiaomiMexico = configSeller.config.s3.FOLDER_APP === 'ti_xiaomi'
  const isOppoMexico = configSeller.config.s3.FOLDER_APP === 'ti_oppo'
  const isElektraMexico = configSeller.config.s3.FOLDER_APP === 'ti_elektra_mx'
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isTelcelMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx'
  const isTelcelCorpMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx'
  const isConectaPeru = configSeller.config.s3.FOLDER_APP === 'ti_conecta_peru'
  const isSamsungRom = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom'
  const isMercadoLibreChile = configSeller.config.s3.FOLDER_APP === 'ti_mercado_libre_cl'
  const isCoppelMexico = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  const { setRunTour, setSteps } = useJoyRideContext()

  // Preguntas raíz del cuestionario estético (las hijas son las alternativas de respuesta).
  const parentQuestions = data.questionList.filter((q: any) => q.id_parent_question === null)

  /* Respuestas de la cotización, armadas con el mismo formato que usaba el cuestionario.
     El peso y el texto se toman del listado de preguntas para no depender de lo que
     traiga guardado el formulario. */
  const quotationAnswers = useMemo(() => {
    if (data.questionList.length === 0) return []
    // Los ids se comparan como número: la API los puede devolver como texto.
    const answers: any[] = Array.isArray(ctx.formAnswers) ? ctx.formAnswers : []
    return answers.reduce((acc: any[], item: any) => {
      const answerOption = data.questionList.find((q: any) => Number(q.id) === Number(item.id_answer))
      if (answerOption === undefined) return acc
      const questionId = Number(answerOption.id_parent_question)
      if (acc.some(a => a.id_question === questionId)) return acc
      acc.push({ id_question: questionId, id_answer: Number(item.id_answer), weigth: answerOption.weigth, answer: answerOption.questions })
      return acc
    }, [])
  }, [ctx.formAnswers, data.questionList])

  const loadData = async () => {
    setLoadingQuestions(true)
    webApiService.getAllQuestions().then(res => {
      if (res.success) {
        setData({ ...data, questionList: res.data, loading: false })
      }
    }).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
      setData({ ...data, loading: false })
    }).finally(() => {
      setLoadingQuestions(false)
    })
  }

  const handleChangeQuestion = (event: ChangeEvent<HTMLInputElement>, idPregunta: number) => {
    console.log('🚀 ~ handleChangeQuestion ~ arrResp:', data.questionList, (event.target as HTMLInputElement).value)

    const arr = [...data.answers]
    console.log('🚀 ~ handleChangeQuestion ~ arr:', arr)

    if (arr.some(e => e.id_question === idPregunta)) {
      const idx = arr.findIndex(e => e.id_question === idPregunta)
      console.log('🚀 ~ handleChangeQuestion ~ idx:', idx)
      arr.splice(idx, 1)
      arr.push({ id_question: idPregunta, id_answer: Number((event.target as HTMLInputElement).value), weigth: data.questionList.find(q => q.id === Number((event.target as HTMLInputElement).value)).weigth, answer: data.questionList.find(q => q.id === Number((event.target as HTMLInputElement).value)).questions })
    } else {
      arr.push({ id_question: idPregunta, id_answer: Number((event.target as HTMLInputElement).value), weigth: data.questionList.find(q => q.id === Number((event.target as HTMLInputElement).value)).weigth, answer: data.questionList.find(q => q.id === Number((event.target as HTMLInputElement).value)).questions })
    }
    console.log('Entro', data.answers.length, data.questionList.filter(q => q.id_parent_question === null).length)
    setData({ ...data, answers: arr })
  }

  const handleClose = () => {
    setData({ ...data, open: false, loading: false, answers: [] })
  }

  const handleRecalculate = async (answers: any[]) => {
    /* El tour se apaga antes de recalcular: con el reload desaparece el botón y su paso
       quedaría apuntando a un elemento que ya no existe, dejando el overlay pegado encima
       de la página (sin scroll ni clicks) y sin pasar al paso siguiente. */
    setRunTour(false)
    setData({ ...data, loading: true })
    const weigth = 100
    let nextGrade = ctx.tradein.grade
    const sumaPeso = answers.reduce((valorAnterior, valorActual) => { return valorAnterior + valorActual.weigth }, 0)
    const result = weigth - sumaPeso
    // Si el grado no se puede determinar con el puntaje obtenido, no se envía el recálculo.
    const gradeNotFound = () => {
      enqueueSnackbar('No se pudo recalcular', { variant: 'error' })
      setData({ ...data, loading: false })
    }
    if (isMacstoreMexico || isOppoMexico || isElektraMexico || isXiaomiMexico || isMercadoLibreChile || isCoppelMexico) {
      if (result === 100) {
        nextGrade = 'A'
      } else if (result > 90) {
        nextGrade = 'B'
      } else if (result > 70) {
        nextGrade = 'C'
      } else {
        gradeNotFound()
        return
      }
    } else if ((isSamsungRom || isConectaPeru)) {
      if (result === 100) {
        nextGrade = 'A'
      } else if (result > 92) {
        nextGrade = 'B'
      } else if (result >= 75) {
        nextGrade = 'C'
      } else {
        gradeNotFound()
        return
      }
    } else if (isSamsungMexico || isTelcelMexico || isTelcelCorpMexico) {
      if (result === 100) {
        nextGrade = 'A'
      } else if (result > 90) {
        nextGrade = 'B'
      } else {
        gradeNotFound()
        return
      }
    }

    const dataForRecalculate = {
      sumaPeso,
      id: ctx.tradein.id,
      marca: ctx.tradein.make,
      modelo: ctx.tradein.modelName,
      capacidad: parseInt(ctx.tradein.memory.split(' ')[0]) + ' ' + ctx.tradein.memory.split(' ')[1],
      capacityTradeIn: ctx.tradein.capacity,
      grado: nextGrade,
      idSeller: ctx.tradein.id_seller,
      answers
    }
    console.log('dataForRecalculate => ', dataForRecalculate)

    try {
      const recalculate = await webApiService.recalculate(dataForRecalculate)
      console.log('🚀 ~ Recalculate ~ newDeviceAmount:', recalculate)

      if (recalculate.data === 0) {
        enqueueSnackbar('No se pudo recalcular', { variant: 'error' })
      }

      setData({ ...data, loading: false, answers: [], open: false })
      saveCtx({ ...ctx, reload: true })
    } catch (error: any) {
      console.log(error)
      enqueueSnackbar(error.message ?? 'No se pudo recalcular', { variant: 'error' })
      setData({ ...data, loading: false })
    }
  }

  // Se compara pregunta por pregunta, no por cantidad: así ninguna queda sin responder.
  const hasAllQuotationAnswers = parentQuestions.length > 0 &&
    parentQuestions.every((p: any) => quotationAnswers.some((a) => a.id_question === Number(p.id)))

  /* El botón recalcula directo con las respuestas de la cotización. Si no las hay para todas
     las preguntas (tradein sin formulario) se abre el cuestionario para responderlas a mano. */
  const handleClickRecalculate = () => {
    if (parentQuestions.length === 0) {
      enqueueSnackbar('No se pudieron cargar las preguntas para recalcular', { variant: 'error' })
      return
    }
    if (SHOW_RECALCULATE_QUESTIONNAIRE || !hasAllQuotationAnswers) {
      setRunTour(false)
      setData({ ...data, open: true, answers: [] })
      return
    }
    handleRecalculate(quotationAnswers)
  }

  useEffect(() => {
    loadData()
    return () => {
      setRunTour(false)
      setData({ loading: false, questionList: [], answers: [], open: false })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // JoyRide: mostrar paso cuando el botón Recalcular es visible
  useEffect(() => {
    setSteps([
      {
        target: '.joyride-recalcular-btn',
        content: 'Presiona este botón para recalcular la evaluación del equipo.',
        placement: 'bottom',
        disableBeacon: true
      }
    ])
    setRunTour(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Button
        className='joyride-recalcular-btn'
        variant='secondary'
        size='sm'
        legacyColor='warning'
        legacyVariant='shadow'
        disabled={data.loading || loadingQuestions}
        onClick={handleClickRecalculate}
      >
        <MdInfo />
        {data.loading || loadingQuestions ? 'Cargando...' : 'Recalcular'}
      </Button>
      {/* Cuestionario estético: solo se abre como respaldo, cuando faltan respuestas de la cotización. */}
      <Modal open={data.open} onClose={handleClose}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            p: 2
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: '800px',
              backgroundColor: 'white',
              borderRadius: 2,
              textAlign: 'center',
              maxHeight: '90vh',
              overflowY: 'auto'
            }}
          >
            <Typography
              id='modal-title'
              variant='h6'
              component='h2'
              sx={{
                backgroundColor: '#333',
                color: '#fff',
                width: '100%',
                padding: 2
              }}
            >
              Evalúa tu equipo
            </Typography>
            <Paper variant='outlined' sx={{ padding: 2 }} className='small'>
              {
                    parentQuestions.map((p:any, i: number) => {
                      return (
                        <div className='mb-2 p-2 rounded shadow' key={i}>
                          <FormControl className='text-start w-100'>
                            <FormLabel id='demo-row-radio-buttons-group-label' className='small'>{textoPregunta(p.questions)}</FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby='demo-row-radio-buttons-group-label'
                              name={'radio-group-' + (i)}
                              onChange={(e) => handleChangeQuestion(e, p.id)}
                              value={data.answers.find(a => a.id_question === p.id)?.id_answer}
                            >
                              {
                                data.questionList.filter((a: any) => Number(a.id_parent_question) === p.id).map((a:any, n: number) => {
                                  return (<FormControlLabel key={n} value={a.id} control={<Radio size='small' />} label={textoPregunta(a.questions)} className='small' />)
                                })
                            }
                            </RadioGroup>
                          </FormControl>
                        </div>
                      )
                    })
                }

            </Paper>
            <Box
              sx={{
                backgroundColor: '#f1f1f1',
                width: '100%',
                padding: 2,
                borderBottomLeftRadius: 5,
                borderBottomRightRadius: 5,
                display: 'flex',
                justifyContent: 'center',
                gap: 2
              }}
            >
              <Button
                variant='destructive'
                disabled={data.loading}
                onClick={handleClose}
              >
                Cerrar
              </Button>
              <Button disabled={data.loading || parentQuestions.length === 0 || parentQuestions.length !== data.answers.length} type='submit' onClick={() => handleRecalculate(data.answers)}>
                {data.loading ? 'Recalculando...' : 'Recalcular'}
              </Button>
            </Box>
          </Box>

        </Box>
      </Modal>
    </div>
  )
}

export default Recalculate
